import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../../../../shared/components/table/table.component';
import { Fila } from '../../../../shared/models/fila';
import { TableHeader } from '../../../../shared/models/table-header';
import { ToastService } from '../../../../shared/services/toast.service';
import { FilaService } from '../../../../shared/services/fila.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastState as ts } from '../../../../shared/enums/toast-state.enum';
import { FilaFilter } from '../../models/fila-filter';
import { SlaDialogFiscalComponent } from './sla-dialog-fiscal/sla-dialog-fiscal.component';
import { LocalId } from '../../../../shared/enums/local.enum';
import { FaseId } from '../../../../shared/enums/fase.enum';

@Component({
  selector: 'app-sla-fila-fiscal',
  imports: [TableComponent, FormsModule],
  templateUrl: './sla-fila-fiscal.component.html',
  styleUrl: './sla-fila-fiscal.component.scss',
})
export class SlaFilaFiscalComponent {
  filaList: Fila[] = [];
  headers: TableHeader[] = [
    { value: 'recebimento.senha', label: 'Senha' },
    { value: 'dataEntrada', label: 'Data Entrada', pipe: 'datetime' },
    { value: 'dataChamada', label: 'Data Chamada', pipe: 'datetime' },
    { value: 'recebimento.milkrun', label: 'Milk Run' },
    { value: 'recebimento.critico', label: 'Crítico' },
  ];

  constructor(
    private toast: ToastService,
    private service: FilaService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadFilaList();
  }

  loadFilaList() {
    const filter: FilaFilter = {
      faseId: FaseId.FISCAL,
      localId: Number(LocalId.SLA),
    };

    this.service.getFiltered(filter).subscribe({
      next: (value) => {
        if (value && value.content) {
          this.filaList = [...value.content];
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Falha ao carregar filas.',
        );
      },
    });
  }

  edit(item: Fila) {
    const dialogRef = this.dialog.open(SlaDialogFiscalComponent, {
      data: item,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Fila atualizada!');
        this.filaList = this.filaList.filter((item) => item.id !== result.id);
      }
    });
  }
}
